'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _mobx = require('mobx');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _mightyFields = require('../../lib/mighty-fields');

var _utils = require('../../utils');

var _FieldSets = require('./main-contacts/FieldSets');

var _FieldSets2 = _interopRequireDefault(_FieldSets);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var getNameOrDefault = _utils.FormattingUtils.getNameOrDefault;
var PlaintiffContactInfo = (_dec = (0, _mobxReact.inject)('FunderStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = function (_Component) {
  _inherits(PlaintiffContactInfo, _Component);

  function PlaintiffContactInfo() {
    _classCallCheck(this, PlaintiffContactInfo);

    return _possibleConstructorReturn(this, (PlaintiffContactInfo.__proto__ || Object.getPrototypeOf(PlaintiffContactInfo)).apply(this, arguments));
  }

  _createClass(PlaintiffContactInfo, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          onPlaintiffInfoChanged = _props.onPlaintiffInfoChanged,
          plaintiff = _props.plaintiff;


      return _react2.default.createElement(_mightyFields.EditableCard, {
        fieldSets: this.fieldSet,
        model: plaintiff,
        onSave: onPlaintiffInfoChanged,
        title: 'Plaintiff'
      });
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: 'fieldSet',
    get: function get() {
      var _this2 = this;

      var FunderStore = this.props.FunderStore;


      return [[{
        field: 'fullname',
        readOnly: true,
        render: function render() {
          return _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)('name', 'fs-mask') },
            getNameOrDefault(_this2.props.plaintiff)
          );
        },
        showLabel: false
      }]].concat(_toConsumableArray((0, _FieldSets2.default)(FunderStore.canSeeSpanishSpeaking)));
    }
  }]);

  return PlaintiffContactInfo;
}(_react.Component), _class3.defaultProps = {
  plaintiff: null
}, _class3.propTypes = {
  FunderStore: _propTypes2.default.object.isRequired,
  onPlaintiffInfoChanged: _propTypes2.default.func.isRequired,
  plaintiff: _propTypes2.default.object
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'fieldSet', [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, 'fieldSet'), _class2.prototype)), _class2)) || _class) || _class) || _class);
var _default = PlaintiffContactInfo;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(getNameOrDefault, 'getNameOrDefault', '/app/src/components/page-case/PlaintiffContactInfo.js');
  reactHotLoader.register(PlaintiffContactInfo, 'PlaintiffContactInfo', '/app/src/components/page-case/PlaintiffContactInfo.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/PlaintiffContactInfo.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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